import * as React from "react";

const CloseScholarship = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
  >
    <rect width="22" height="22" fill="#000" rx="11"></rect>
    <path
      fill="#fff"
      stroke="#fff"
      strokeLinejoin="round"
      d="m15.793 6.6-4.047 4.047a.5.5 0 0 0 0 .707l4.047 4.046-.393.393-4.046-4.047a.5.5 0 0 0-.63-.063l-.078.063L6.6 15.793l-.393-.393 4.047-4.046a.5.5 0 0 0 .063-.63l-.063-.078L6.207 6.6l.393-.393 4.047 4.047a.5.5 0 0 0 .707 0L15.4 6.207z"
    ></path>
  </svg>
);

export default CloseScholarship;
